import React from 'react';
import { useState } from 'react';

import { connect } from 'react-redux';

import FormInput from '../../components/form-input/form-input.component';
import CustomButton from '../../components/custom-button/custom-button.component';
import Button from '@material-ui/core/Button';


import { emailSignInStart } from '../../redux/user/user.actions';

import { MacroContainer, SignInContainer, TitleContainer, LogoContainer } from './sign-in-page.styles';
import history from '../../history';



const SignInPage = ({ emailSignInStart }) => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');


    const handleSubmit = async event => {
        event.preventDefault();
        await emailSignInStart(email, password);
    };

    const handleChange = event => {
        const { value, name } = event.target;
        if (name === 'email') setEmail(value);
        else setPassword(value);
    };
        
    return (
        <MacroContainer>
        <SignInContainer>
                <LogoContainer>
                    <img id="logo" alt="logo"  src={require("../../assets/mrsLogo.png")} height="auto" width="100%" />
            </LogoContainer>
            <TitleContainer>I want to reserve a Mass!</TitleContainer>
            <span>Sign in with your email and password</span>


            <form onSubmit={(e) => handleSubmit(e)} autoComplete="on">
                <FormInput 
                    name="email" 
                    type="email" 
                    value={email} 
                    handleChange={(e) => handleChange(e)}
                    label="Email"
                    required 
                />
                <FormInput 
                    name="password" 
                    type = "password" 
                    value={password} 
                    handleChange={(e) => handleChange(e)}
                    label="Password"
                    required 
                />

                <CustomButton type="submit">Sign in</CustomButton>

            </form> 
            
            <Button color="secondary" style={{fontSize: "18px", marginTop: "20px", width: "300px", textAlign: "left"}} 
                onClick={() => history.push('/resetpassword')}>I forgot my password.</Button>

            <Button color="primary" style={{fontSize: "18px", marginTop: "20px", width: "300px", textAlign: "left"}} 
                onClick={() => history.push('/register')}>I don't have an account.</Button>
                

        </SignInContainer>
        </MacroContainer>
    )
}


const mapDispatchToProps = dispatch => ({
    emailSignInStart: (email, password) => dispatch(emailSignInStart({ email, password }))
});

export default connect(null, mapDispatchToProps)(SignInPage);


